<template>
  <transition name="toast-fade">
    <div class="toast" v-show="showToast">
      <span class="text">{{message}}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      showToast:  false,
      message: 'a message',
      type: 'info',
      duration: 3000
    }
  },
  computed: {
    // TODO 不同的提示类型使用不同OOXX
  },
  beforeDestroy() {
    this.$el && documen.body.removeChild($el)
  },
  methods: {
    show() {
    // 元素添加到DOM中
      document.body.appendChild(this.$el)
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, this.duration);
    }
  }
};
</script>

<style>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  border-radius: .1rem;
  max-width: 80%;
  font-size: .24rem;
  padding: .2rem .5rem;
  color: #ffffff;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toast-fade-enter-active {
  animation: toast-fadein .3s;
}
.toast-fade-leave-active {
  animation: toast-fadeout .3s;
}

@keyframes toast-fadein {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
@keyframes toast-fadeout {
  0% {opacity: 1;}
  100% {opacity: 0;}
}
</style>


// WEBPACK FOOTER //
// src/components/Toast/Toast.vue